import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MoreHorizOutlined, ReplyOutlined, EditOutlined, DeleteOutlined } from '@mui/icons-material';
import { RightsContext } from 'providers/RightsContext';
import { Button, Dialog, IconButton, Typography } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

function DocumentCommentActionsComponent({ comment, onReplyComment, onEditComment, onDeleteComment }) {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const { deleteDocumentComments } = useContext(RightsContext);

  return (
    <>
      <IconButton
        disabled={!comment.canReply && !comment.canEdit && (!deleteDocumentComments || !comment.canDelete)}
        variant='text'
        size='tiny'
        color='primary'
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        <MoreHorizOutlined fontSize='small' />
      </IconButton>
      <Menu id='basic-menu' anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} variant='menu'>
        {comment.canReply && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              onReplyComment(comment.commentId);
            }}
          >
            <ListItemIcon>
              <ReplyOutlined fontSize='small' />
            </ListItemIcon>
            <Typography variant='inherit'>{t('Offer.Comments.Reply')}</Typography>
          </MenuItem>
        )}
        {comment.canEdit && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              onEditComment(comment.commentId);
            }}
          >
            <ListItemIcon>
              <EditOutlined fontSize='small' />
            </ListItemIcon>
            <Typography variant='inherit'>{t('Offer.Comments.Edit')}</Typography>
          </MenuItem>
        )}
        {deleteDocumentComments && comment.canDelete && (
          <MenuItem
            onClick={() => {
              setOpen(true);
              setAnchorEl(null);
            }}
          >
            <ListItemIcon>
              <DeleteOutlined fontSize='small' />
            </ListItemIcon>
            <Typography variant='inherit'>{t('Delete')}</Typography>
          </MenuItem>
        )}
      </Menu>
      <Dialog
        open={open}
        aria-labelledby='comment-actions-dialog-title'
        fullWidth={true}
        maxWidth={'sm'}
        transitionDuration={0}
        scroll='body'
        title={t('Offer.Comments.DialogActionTitle')}
        content={t('Offer.Comments.DialogActionSubtitle')}
        actions={
          <BoxActionsWrapper forDialog>
            <Button
              color='primary'
              variant='outlined'
              onClick={() => {
                setOpen(false);
              }}
            >
              {t('Cancel')}
            </Button>
            <Button
              color='primary'
              variant='contained'
              onClick={() => {
                onDeleteComment(comment.commentId);
                setOpen(false);
              }}
            >
              {t('Delete')}
            </Button>
          </BoxActionsWrapper>
        }
      />
    </>
  );
}

DocumentCommentActionsComponent.propTypes = {
  comment: PropTypes.object.isRequired,
  onReplyComment: PropTypes.func.isRequired,
  onEditComment: PropTypes.func.isRequired,
  onDeleteComment: PropTypes.func.isRequired
};

export default DocumentCommentActionsComponent;
